export class VirkesorderstatusIndicatorTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        saknas: "Saknas"
    };
}
